import { render, staticRenderFns } from "./AiPromptSetting.vue?vue&type=template&id=0ca03e5a&scoped=true"
import script from "./AiPromptSetting.vue?vue&type=script&lang=js"
export * from "./AiPromptSetting.vue?vue&type=script&lang=js"
import style0 from "./AiPromptSetting.vue?vue&type=style&index=0&id=0ca03e5a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ca03e5a",
  null
  
)

export default component.exports